import React, { useState } from "react";
import classes from "./GSTReconciliation.module.css";
import BoxWrapper from "../../../../components/ui/boxWrapper";

function MissingInGSTR(props) {
  const { missingInGSTRData } = props;
  const [missingInGSTRTableData, setMissingInGSTRTableData] =
    useState(missingInGSTRData);

  const searchInputHandler = (event) => {
    let searchInput = event.target.value;
    let searchData = missingInGSTRData.filter((value) => {
      const query = searchInput.toLowerCase();
      return (
        String(value.cust_gstin).toLowerCase().indexOf(query) >= 0 ||
        String(value.cust_name).toLowerCase().indexOf(query) >= 0 ||
        String(value.invoice_no).toLowerCase().indexOf(query) >= 0 ||
        String(value.invoice_date).toLowerCase().indexOf(query) >= 0 ||
        String(value.invoice_type).toLowerCase().indexOf(query) >= 0
      );
    });
    setMissingInGSTRTableData(searchData);
  };

  // indian rupeess system---
  const numberFormat = (value) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumSignificantDigits: 10,
    }).format(value);
  // ---End---

  const missingInGSTRTableBody = () => {
    if (missingInGSTRTableData.length >= 1) {
      return missingInGSTRTableData.map((tableData, index) => {
        const {
          cust_gstin,
          cust_name,
          cws_cess,
          cws_cgst,
          cws_igst,
          cws_sgst,
          cws_taxable_value,
          cws_total_amount,
          invoice_date,
          invoice_no,
          invoice_type,
        } = tableData;
        return (
          <tr>
            <td>{cust_gstin}</td>
            <td>{cust_name}</td>
            <td>{invoice_no}</td>
            <td>{invoice_date}</td>
            <td>{invoice_type}</td>
            <td>{numberFormat(cws_taxable_value)}</td>
            <td>{numberFormat(cws_cgst)}</td>
            <td>{numberFormat(cws_sgst)}</td>
            <td>{numberFormat(cws_igst)}</td>
            <td>{numberFormat(cws_cess)}</td>
            <td>{numberFormat(cws_total_amount)}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan={11} style={{ color: "red", textAlign: "left" }}>
            No Data Found!
          </td>
        </tr>
      );
    }
  };

  return (
    <>
      <BoxWrapper
        boxTitle="Reconciliation Status : Invoice(s) Missing in GSTR-1"
        // search input
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={searchInputHandler}
      >
        <div className={classes.ResponsiveTable}>
          <table className={classes.missingInAccountTableCss}>
            <tr>
              <th rowSpan={2}>GSTIN</th>
              <th rowSpan={2} align="right">
                CUSTOMER NAME
              </th>
              <th rowSpan={2} align="right">
                INVOICE/CN/DN/NUMBER
              </th>
              <th rowSpan={2} align="right">
                DATE
              </th>
              <th rowSpan={2} align="right">
                TYPE
              </th>
              <th style={{ background: "#ffffb3" }} colSpan={6} align="center">
                As per Books
              </th>
            </tr>
            <tr>
              <th style={{ background: "#ffffb3" }} align="right">
                TAXABLE VALUE
              </th>
              <th style={{ background: "#ffffb3" }} align="right">
                CGST
              </th>
              <th style={{ background: "#ffffb3" }} align="right">
                SGST
              </th>
              <th style={{ background: "#ffffb3" }} align="right">
                IGST
              </th>
              <th style={{ background: "#ffffb3" }} align="right">
                CESS
              </th>
              <th style={{ background: "#ffffb3" }} align="right">
                TOTAL AMOUNT
              </th>
            </tr>
            {missingInGSTRTableBody()}
          </table>
        </div>
      </BoxWrapper>
    </>
  );
}

export default MissingInGSTR;
